import React from 'react';
import { motion } from 'framer-motion';
import { FaEdit, FaTrash, FaEye, FaEyeSlash } from 'react-icons/fa';

const BlogCategoryCard = ({
    category,
    onEdit,
    onDelete,
    onToggleStatus
}) => {
    const handleEdit = (e) => {
        e.stopPropagation();
        onEdit && onEdit(category);
    };

    const handleDelete = (e) => {
        e.stopPropagation();
        onDelete && onDelete(category);
    };

    const handleToggleStatus = (e) => {
        e.stopPropagation();
        onToggleStatus && onToggleStatus(category);
    };

    return (
        <motion.div
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 hover:shadow-md transition-shadow duration-200 cursor-pointer"
        >
            <div className="flex items-start justify-between mb-3">
                <div className="flex items-center space-x-3 flex-1 min-w-0">
                    <div className="w-10 h-10 rounded-lg flex-shrink-0 flex items-center justify-center" style={{ backgroundColor: category.color + '20' }}>
                        {category.icon ? (
                            <img src={category.icon} alt={category.name} className="w-6 h-6 object-cover" />
                        ) : (
                            <div className="w-6 h-6 rounded" style={{ backgroundColor: category.color }}></div>
                        )}
                    </div>
                    <div className="flex-1 min-w-0">
                        <h3 className="text-lg font-semibold text-gray-900 truncate">{category.name}</h3>
                        {category.description && (
                            <p className="text-sm text-gray-600 mt-1 line-clamp-2">{category.description}</p>
                        )}
                    </div>
                </div>
                <div className="flex items-center space-x-1 flex-shrink-0 ml-2">
                    <button
                        onClick={handleToggleStatus}
                        className={`p-1.5 rounded-full transition-colors ${category.is_active
                            ? 'text-green-600 hover:bg-green-50'
                            : 'text-gray-400 hover:bg-gray-50'
                            }`}
                        title={category.is_active ? 'Deactivate' : 'Activate'}
                    >
                        {category.is_active ? <FaEye size={12} /> : <FaEyeSlash size={12} />}
                    </button>
                    <button
                        onClick={handleEdit}
                        className="p-1.5 text-blue-600 hover:bg-blue-50 rounded-full transition-colors"
                        title="Edit"
                    >
                        <FaEdit size={12} />
                    </button>
                    <button
                        onClick={handleDelete}
                        className="p-1.5 text-red-600 hover:bg-red-50 rounded-full transition-colors"
                        title="Delete"
                    >
                        <FaTrash size={12} />
                    </button>
                </div>
            </div>

            <div className="flex items-center justify-between text-sm text-gray-500">
                <div className="flex items-center space-x-2">
                    <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded-full text-xs">
                        Order: {category.order}
                    </span>
                    <span className={`px-2 py-1 rounded-full text-xs ${category.is_active
                        ? 'bg-green-100 text-green-800'
                        : 'bg-gray-100 text-gray-800'
                        }`}>
                        {category.is_active ? 'Active' : 'Inactive'}
                    </span>
                </div>
                <div className="text-xs text-gray-400">
                    {new Date(category.created_at).toLocaleDateString()}
                </div>
            </div>
        </motion.div>
    );
};

export default BlogCategoryCard;
